import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import * as AmplifyModules from 'aws-amplify'
import awsConfig from './aws-exports';
import router from './router'
import { store } from './store/root';
import { Amplify, Logger } from 'aws-amplify';
import { useDoorValues } from '@/const/useDoorValues';
import JsonCSV from 'vue-json-csv';

Amplify.configure(awsConfig)
loadFonts()

const logger = new Logger('main.js');

window.LOG_LEVEL = process.env.VUE_APP_LOG_LEVEL || 'VERBOSE'
const message = process.env.VUE_APP_LOAD_COMPLETE_MESSAGE || 'load_complete'

const { decideOriginUrl } = useDoorValues()

window.addEventListener('load', () => {
  const url = new URL(document.referrer);
  const origin = url.origin;
  logger.info('origin referrer', origin)

  if (window.opener === null) {
    return
  }
  const doorUrls = decideOriginUrl(origin)
  if (doorUrls.length === 0) {
    logger.info('No match postMessage origin', origin)
    return
  }
  logger.info('Send Message to', doorUrls[0])
  window.opener.postMessage(message, doorUrls[0])
})

const app = createApp(App)
  .use(vuetify)
  .use(AmplifyModules)
  .use(router)
  .use(store);

  app.component('downloadCsv', JsonCSV);
  app.mount('#app')

